export const CISCO = {
  id: "cisco",
  name: "CISCO",
  imageFolder: "/cisco",
  tagline: {
    pt: "Redes empresariais Cisco — Switching, Roteamento e Wi-Fi para pequenas e médias empresas.",
    en: "Cisco enterprise networking — Switching, Routing and Wi-Fi for small and mid-size businesses.",
    es: "Redes empresariales Cisco — Switching, Routing y Wi-Fi para pequeñas y medianas empresas.",
  },
  color: "#4f46e5",
  theme: {
    bgGradient: "from-[#eef1fb] via-[#d8e8f5] to-[#eef4fb]",
    blob1: "bg-indigo-300/30",
    blob2: "bg-blue-200/40",
    overlineText: "text-indigo-700",
    pillarPill: "border-indigo-400 text-indigo-700",
    segmentHover: "hover:border-indigo-400",
    tabHover: "hover:border-indigo-400 hover:text-indigo-700",
    ctaPrimary:
      "bg-indigo-600 hover:bg-indigo-700 shadow-indigo-600/25 hover:shadow-indigo-600/40",
    ctaOutline: "border-indigo-400 text-indigo-700 hover:bg-indigo-50",
    productHover: "hover:border-indigo-400",
    productQuoteCta: "border-indigo-400 text-indigo-700 hover:bg-indigo-50",
    productBadge: "text-indigo-700",
    productPreviewPill: "text-indigo-700",
    whyPanel: "border-indigo-200 from-indigo-50 to-white",
    whyItemBorder: "border-indigo-100",
    whyCheck: "text-indigo-600",
    modalHeaderBg: "from-indigo-50 via-[#d8e8f5] to-blue-50",
    modalBrandBadge: "border-indigo-200 text-indigo-700",
    modalInputFocus: "focus:border-indigo-500 focus:ring-indigo-500/20",
    modalSubmit:
      "bg-indigo-600 hover:bg-indigo-700 shadow-indigo-600/25 hover:shadow-indigo-600/40",
  },
  pillars: {
    pt: ["Switching", "Wireless", "Routing", "SD-WAN"],
    en: ["Switching", "Wireless", "Routing", "SD-WAN"],
    es: ["Switching", "Wireless", "Routing", "SD-WAN"],
  },
  segments: {
    pt: [
      { name: "Escritórios", desc: "Rede Wi-Fi corporativa segura, gestão na nuvem e cobertura total." },
      { name: "Retalho", desc: "Lojas conectadas, POS fiável e segmentação de rede de clientes." },
      { name: "Filiais", desc: "Conectividade SD-WAN entre sedes e filiais com segurança integrada." },
      { name: "Hotelaria", desc: "Wi-Fi premium para hóspedes, rede corporativa isolada e analytics." },
      { name: "Educação", desc: "Escolas e universidades com redes escaláveis e gestão centralizada." },
      { name: "Saúde", desc: "Clínicas e hospitais com rede segura e elevada disponibilidade." },
      { name: "Indústria", desc: "Conectividade industrial com redundância e SD-WAN segura." },
    ],
    en: [
      { name: "Offices", desc: "Secure corporate Wi-Fi, cloud management and full coverage." },
      { name: "Retail", desc: "Connected stores, reliable POS and guest network segmentation." },
      { name: "Branches", desc: "SD-WAN connectivity between HQ and branches with built-in security." },
      { name: "Hospitality", desc: "Premium guest Wi-Fi, isolated corporate network and analytics." },
      { name: "Education", desc: "Schools and universities with scalable networks and central management." },
      { name: "Healthcare", desc: "Clinics and hospitals with secure, highly-available networks." },
      { name: "Industry", desc: "Industrial connectivity with redundancy and secure SD-WAN." },
    ],
    es: [
      { name: "Oficinas", desc: "Wi-Fi corporativo seguro, gestión en la nube y cobertura total." },
      { name: "Retail", desc: "Tiendas conectadas, POS fiable y segmentación de red de invitados." },
      { name: "Sucursales", desc: "Conectividad SD-WAN entre sede y sucursales con seguridad integrada." },
      { name: "Hotelería", desc: "Wi-Fi premium para huéspedes, red corporativa aislada y analytics." },
      { name: "Educación", desc: "Escuelas y universidades con redes escalables y gestión central." },
      { name: "Salud", desc: "Clínicas y hospitales con red segura y alta disponibilidad." },
      { name: "Industria", desc: "Conectividad industrial con redundancia y SD-WAN segura." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher a Cisco?",
      items: [
        "Líder mundial em networking empresarial",
        "Gestão 100% na cloud com Meraki Dashboard",
        "Segurança integrada e SD-WAN nativa",
        "Atualizações de segurança contínuas",
        "Escalabilidade de escritório a multi-sítio",
        "Assistência e instalação em Angola",
      ],
    },
    en: {
      title: "Why choose Cisco?",
      items: [
        "Global leader in enterprise networking",
        "100% cloud management with Meraki Dashboard",
        "Built-in security and native SD-WAN",
        "Continuous security updates",
        "Scales from single office to multi-site",
        "Local support and installation in Angola",
      ],
    },
    es: {
      title: "¿Por qué elegir Cisco?",
      items: [
        "Líder global en networking empresarial",
        "Gestión 100% en la nube con Meraki Dashboard",
        "Seguridad integrada y SD-WAN nativa",
        "Actualizaciones de seguridad continuas",
        "Escala de oficina única a multi-sitio",
        "Soporte e instalación local en Angola",
      ],
    },
  },
  groups: [
    {
      id: "switching",
      icon: "network",
      featured: true,
      title: {
        pt: "Switching — Catalyst & Meraki MS",
        en: "Switching — Catalyst & Meraki MS",
        es: "Switching — Catalyst y Meraki MS",
      },
      description: {
        pt: "Switches empresariais e de acesso com inteligência de camada 3, PoE+, uplinks em fibra e stacking — do pequeno escritório à sede multi-andar.",
        en: "Enterprise and access switches with Layer 3 intelligence, PoE+, fiber uplinks and stacking — from a small office to a multi-floor HQ.",
        es: "Switches empresariales y de acceso con inteligencia Layer 3, PoE+, uplinks de fibra y stacking — de la oficina pequeña a la sede multi-piso.",
      },
      highlights: {
        pt: [
          "Camada 2 e 3 com routing avançado",
          "PoE+ até 90 W por porta (IEEE 802.3bt)",
          "Uplinks SFP / SFP+ até 10 Gbps",
          "Stacking físico e virtual",
          "Gestão on-prem (Catalyst Center) ou cloud (Meraki)",
          "QoS e segmentação VLAN / VXLAN",
          "Atualizações de segurança contínuas",
        ],
        en: [
          "Layer 2 and Layer 3 with advanced routing",
          "PoE+ up to 90W per port (IEEE 802.3bt)",
          "SFP / SFP+ uplinks up to 10 Gbps",
          "Physical and virtual stacking",
          "On-prem (Catalyst Center) or cloud (Meraki) management",
          "QoS and VLAN / VXLAN segmentation",
          "Continuous security updates",
        ],
        es: [
          "Capa 2 y 3 con routing avanzado",
          "PoE+ hasta 90 W por puerto (IEEE 802.3bt)",
          "Uplinks SFP / SFP+ hasta 10 Gbps",
          "Stacking físico y virtual",
          "Gestión on-prem (Catalyst Center) o cloud (Meraki)",
          "QoS y segmentación VLAN / VXLAN",
          "Actualizaciones de seguridad continuas",
        ],
      },
      products: [
        {
          slug: "catalyst-1300",
          pt: "Catalyst 1300 Series — Switches Gigabit geridos camada 3 para PME",
          en: "Catalyst 1300 Series — Managed Layer 3 Gigabit switches for SMBs",
          es: "Catalyst 1300 Series — Switches Gigabit gestionados Layer 3 para pymes",
        },
        {
          slug: "catalyst-9200",
          pt: "Catalyst 9200 Series — Switches de acesso empresariais stackáveis com PoE+",
          en: "Catalyst 9200 Series — Stackable enterprise access switches with PoE+",
          es: "Catalyst 9200 Series — Switches de acceso empresariales apilables con PoE+",
        },
        {
          slug: "catalyst-9300",
          pt: "Catalyst 9300 Series — Switching empresarial de alto desempenho com stacking 480 Gbps",
          en: "Catalyst 9300 Series — High-performance enterprise switching with 480 Gbps stacking",
          es: "Catalyst 9300 Series — Switching empresarial de alto rendimiento con stacking 480 Gbps",
        },
        {
          slug: "meraki-ms130",
          pt: "Meraki MS130 — Switches de acesso camada 3 geridos na cloud",
          en: "Meraki MS130 — Cloud-managed Layer 3 access switches",
          es: "Meraki MS130 — Switches de acceso Layer 3 gestionados en la nube",
        },
        {
          slug: "meraki-ms225",
          pt: "Meraki MS225 — Switches de agregação cloud com uplinks 10 G SFP+",
          en: "Meraki MS225 — Cloud aggregation switches with 10G SFP+ uplinks",
          es: "Meraki MS225 — Switches de agregación cloud con uplinks 10G SFP+",
        },
      ],
    },
    {
      id: "wireless",
      icon: "antenna",
      title: {
        pt: "Wireless — Wi-Fi 6 / 6E",
        en: "Wireless — Wi-Fi 6 / 6E",
        es: "Wireless — Wi-Fi 6 / 6E",
      },
      description: {
        pt: "Access points empresariais Wi-Fi 6 e 6E — cobertura estável, desempenho elevado, roaming rápido e segurança WPA3 para escritórios, hotéis, escolas e retalho.",
        en: "Enterprise Wi-Fi 6 and 6E access points — stable coverage, high performance, fast roaming and WPA3 security for offices, hotels, schools and retail.",
        es: "Access points empresariales Wi-Fi 6 y 6E — cobertura estable, alto rendimiento, roaming rápido y seguridad WPA3 para oficinas, hoteles, escuelas y retail.",
      },
      highlights: {
        pt: [
          "Wi-Fi 6 e 6E (6 GHz) para alta densidade",
          "MU-MIMO e OFDMA",
          "WPA3 e segurança empresarial",
          "Roaming sem interrupção entre APs",
          "Gestão on-prem ou 100% cloud",
          "Deployment zero-touch",
        ],
        en: [
          "Wi-Fi 6 and 6E (6 GHz) for high density",
          "MU-MIMO and OFDMA",
          "WPA3 and enterprise security",
          "Seamless roaming between APs",
          "On-prem or 100% cloud management",
          "Zero-touch deployment",
        ],
        es: [
          "Wi-Fi 6 y 6E (6 GHz) para alta densidad",
          "MU-MIMO y OFDMA",
          "WPA3 y seguridad empresarial",
          "Roaming continuo entre APs",
          "Gestión on-prem o 100% cloud",
          "Deployment zero-touch",
        ],
      },
      products: [
        {
          slug: "catalyst-9136",
          pt: "Catalyst 9136 — Access point Wi-Fi 6E de topo para alta densidade",
          en: "Catalyst 9136 — Flagship Wi-Fi 6E access point for high density",
          es: "Catalyst 9136 — Access point Wi-Fi 6E top para alta densidad",
        },
        {
          slug: "catalyst-9164",
          pt: "Catalyst 9164 Series — Access points Wi-Fi 6E on-prem ou cloud",
          en: "Catalyst 9164 Series — Wi-Fi 6E access points, on-prem or cloud",
          es: "Catalyst 9164 Series — Access points Wi-Fi 6E on-prem o cloud",
        },
        {
          slug: "catalyst-9166",
          pt: "Catalyst 9166 — Access point Wi-Fi 6E tri-banda para escritórios modernos",
          en: "Catalyst 9166 — Tri-band Wi-Fi 6E access point for modern offices",
          es: "Catalyst 9166 — Access point Wi-Fi 6E tri-banda para oficinas modernas",
        },
        {
          slug: "meraki-mr36",
          pt: "Meraki MR36 — Access point Wi-Fi 6 2x2:2 gerido na cloud",
          en: "Meraki MR36 — Cloud-managed 2x2:2 Wi-Fi 6 access point",
          es: "Meraki MR36 — Access point Wi-Fi 6 2x2:2 gestionado en la nube",
        },
        {
          slug: "meraki-mr44",
          pt: "Meraki MR44 — Access point Wi-Fi 6 4x4:4 com gestão cloud",
          en: "Meraki MR44 — Cloud-managed 4x4:4 Wi-Fi 6 access point",
          es: "Meraki MR44 — Access point Wi-Fi 6 4x4:4 con gestión cloud",
        },
        {
          slug: "meraki-mr46",
          pt: "Meraki MR46 — Access point Wi-Fi 6 de alto desempenho",
          en: "Meraki MR46 — High-performance Wi-Fi 6 access point",
          es: "Meraki MR46 — Access point Wi-Fi 6 de alto rendimiento",
        },
      ],
    },
    {
      id: "routing",
      icon: "globe",
      title: {
        pt: "Routing — Catalyst 8000 & ISR",
        en: "Routing — Catalyst 8000 & ISR",
        es: "Routing — Catalyst 8000 y ISR",
      },
      description: {
        pt: "Routers empresariais para sedes, filiais e escritórios remotos — conectividade multi-WAN, WAN redundante, túneis VPN e encaminhamento dinâmico.",
        en: "Enterprise routers for HQs, branches and remote offices — multi-WAN connectivity, WAN redundancy, VPN tunnels and dynamic routing.",
        es: "Routers empresariales para sedes, sucursales y oficinas remotas — conectividad multi-WAN, WAN redundante, túneles VPN y routing dinámico.",
      },
      highlights: {
        pt: [
          "Multi-WAN com failover automático",
          "VPN IPsec site-to-site e cliente",
          "Encaminhamento dinâmico (OSPF, BGP)",
          "QoS e priorização de tráfego",
          "Segurança integrada (Zero Trust)",
          "Módulos LTE / 5G opcionais",
        ],
        en: [
          "Multi-WAN with automatic failover",
          "Site-to-site and client IPsec VPN",
          "Dynamic routing (OSPF, BGP)",
          "QoS and traffic prioritization",
          "Integrated security (Zero Trust)",
          "Optional LTE / 5G modules",
        ],
        es: [
          "Multi-WAN con failover automático",
          "VPN IPsec site-to-site y cliente",
          "Routing dinámico (OSPF, BGP)",
          "QoS y priorización de tráfico",
          "Seguridad integrada (Zero Trust)",
          "Módulos LTE / 5G opcionales",
        ],
      },
      products: [
        {
          slug: "catalyst-8200",
          pt: "Catalyst 8200 Series — Router empresarial compacto para filiais",
          en: "Catalyst 8200 Series — Compact enterprise router for branches",
          es: "Catalyst 8200 Series — Router empresarial compacto para sucursales",
        },
        {
          slug: "catalyst-8300",
          pt: "Catalyst 8300 Series — Router edge empresarial modular de alto desempenho",
          en: "Catalyst 8300 Series — High-performance modular enterprise edge router",
          es: "Catalyst 8300 Series — Router edge empresarial modular de alto rendimiento",
        },
        {
          slug: "isr-1000",
          pt: "ISR 1000 Series — Router integrado para PME e escritórios remotos",
          en: "ISR 1000 Series — Integrated services router for SMB and remote offices",
          es: "ISR 1000 Series — Router integrado para pymes y oficinas remotas",
        },
        {
          slug: "meraki-z3",
          pt: "Meraki Z3 — Gateway teleworker VPN para home-office seguro",
          en: "Meraki Z3 — Teleworker VPN gateway for secure home-office",
          es: "Meraki Z3 — Gateway teleworker VPN para home-office seguro",
        },
      ],
    },
    {
      id: "sdwan",
      icon: "shield",
      title: {
        pt: "SD-WAN & Segurança — Meraki MX",
        en: "SD-WAN & Security — Meraki MX",
        es: "SD-WAN y Seguridad — Meraki MX",
      },
      description: {
        pt: "Appliances Cisco Meraki MX e Catalyst SD-WAN geridos na cloud: firewall de próxima geração, SD-WAN integrada, IPS/IDS, VPN site-to-site e gestão por dashboard único.",
        en: "Cloud-managed Cisco Meraki MX and Catalyst SD-WAN appliances: next-generation firewall, integrated SD-WAN, IPS/IDS, site-to-site VPN and single-dashboard management.",
        es: "Appliances Cisco Meraki MX y Catalyst SD-WAN gestionados en la nube: firewall de nueva generación, SD-WAN integrada, IPS/IDS, VPN site-to-site y gestión por dashboard único.",
      },
      highlights: {
        pt: [
          "Firewall de nova geração (NGFW)",
          "SD-WAN dinâmica multi-WAN",
          "IPS / IDS integrados",
          "Anti-malware avançado (AMP)",
          "VPN site-to-site e cliente",
          "Filtragem de conteúdo e categorias",
          "Gestão 100% cloud (Meraki Dashboard)",
          "Auto-VPN em minutos",
        ],
        en: [
          "Next-generation firewall (NGFW)",
          "Dynamic multi-WAN SD-WAN",
          "Integrated IPS / IDS",
          "Advanced malware protection (AMP)",
          "Site-to-site and client VPN",
          "Content and category filtering",
          "100% cloud management (Meraki Dashboard)",
          "Auto-VPN in minutes",
        ],
        es: [
          "Firewall de nueva generación (NGFW)",
          "SD-WAN dinámica multi-WAN",
          "IPS / IDS integrados",
          "Anti-malware avanzado (AMP)",
          "VPN site-to-site y cliente",
          "Filtrado de contenidos y categorías",
          "Gestión 100% cloud (Meraki Dashboard)",
          "Auto-VPN en minutos",
        ],
      },
      products: [
        {
          slug: "meraki-mx65",
          pt: "Meraki MX65 — Appliance de segurança para escritórios pequenos",
          en: "Meraki MX65 — Small-office security appliance",
          es: "Meraki MX65 — Appliance de seguridad para oficinas pequeñas",
        },
        {
          slug: "meraki-mx67",
          pt: "Meraki MX67 — Router SD-WAN para filiais e locais remotos",
          en: "Meraki MX67 — SD-WAN router for branches and remote sites",
          es: "Meraki MX67 — Router SD-WAN para sucursales y sitios remotos",
        },
        {
          slug: "meraki-mx68",
          pt: "Meraki MX68 — SD-WAN com mais portas e desempenho superior",
          en: "Meraki MX68 — SD-WAN with more ports and higher performance",
          es: "Meraki MX68 — SD-WAN con más puertos y mayor rendimiento",
        },
        {
          slug: "meraki-mx75",
          pt: "Meraki MX75 — SD-WAN rack-mount para sedes em crescimento",
          en: "Meraki MX75 — Rack-mount SD-WAN for growing HQs",
          es: "Meraki MX75 — SD-WAN rack-mount para sedes en crecimiento",
        },
        {
          slug: "meraki-mx85",
          pt: "Meraki MX85 — SD-WAN rack-mount de alto desempenho com SFP",
          en: "Meraki MX85 — High-performance rack-mount SD-WAN with SFP",
          es: "Meraki MX85 — SD-WAN rack-mount de alto rendimiento con SFP",
        },
        {
          slug: "meraki-mx95",
          pt: "Meraki MX95 — SD-WAN empresarial multi-Gigabit com redundância",
          en: "Meraki MX95 — Multi-Gigabit enterprise SD-WAN with redundancy",
          es: "Meraki MX95 — SD-WAN empresarial multi-Gigabit con redundancia",
        },
        {
          slug: "catalyst-8000v",
          pt: "Catalyst 8000V — Router virtual SD-WAN para cloud e data center",
          en: "Catalyst 8000V — Virtual SD-WAN router for cloud and data center",
          es: "Catalyst 8000V — Router virtual SD-WAN para cloud y data center",
        },
      ],
    },
    {
      id: "dashboard",
      icon: "dashboard",
      title: {
        pt: "Gestão Unificada — Meraki & SD-WAN Manager",
        en: "Unified Management — Meraki & SD-WAN Manager",
        es: "Gestión Unificada — Meraki y SD-WAN Manager",
      },
      description: {
        pt: "Painéis unificados na cloud para gerir toda a rede (MX, MS, MR) e topologias SD-WAN — visibilidade em tempo real, alertas proativos e deployment zero-touch.",
        en: "Unified cloud dashboards to manage the entire network (MX, MS, MR) and SD-WAN topologies — real-time visibility, proactive alerts and zero-touch deployment.",
        es: "Paneles unificados en la nube para gestionar toda la red (MX, MS, MR) y topologías SD-WAN — visibilidad en tiempo real, alertas proactivas y deployment zero-touch.",
      },
      products: [
        {
          slug: "meraki-dashboard",
          pt: "Meraki Dashboard — Plataforma de gestão cloud para MX, MS e MR",
          en: "Meraki Dashboard — Cloud management platform for MX, MS and MR",
          es: "Meraki Dashboard — Plataforma de gestión cloud para MX, MS y MR",
        },
        {
          slug: "sdwan-manager",
          pt: "Catalyst SD-WAN Manager — Gestão centralizada de topologias SD-WAN",
          en: "Catalyst SD-WAN Manager — Centralized management of SD-WAN topologies",
          es: "Catalyst SD-WAN Manager — Gestión centralizada de topologías SD-WAN",
        },
      ],
    },
  ],
};
